enum UnfreezeForecast {
  UNFREEZE_FORECAST = 'billing-periods/unfreeze-forecast'
}
export default UnfreezeForecast;
